export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const CALLBACK_URL = process.env.SMILEFY_CALLBACK_URL || 'smilefyappconnections://';
export const APP_URL= process.env.REACT_APP_BASE_URL;
export const APP_DATA = {
  WELCOME_ROUTER: "/drive",
  LOGIN_ROUTE: "/login",

}